<template>
  <div>
    <div class="form-container ou-donation-form jlic-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount:">
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD', 'ILS']" />
            </FormRow>
            <AmountSelector />
            <ErrorLabel field="amount" />
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency:">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly monthlyText="Monthly" />
            </div>
          </FormSection>
          <FormSection title="Donation information:">
            <div
              style="
                font-size: 14px;
                color: #222;
                padding-top: 3px;
                padding-bottom: 3px;
                margin-bottom: 5px;
              "
            >
            Choose a Specific Campus, Community or Project for attribution:
            </div>
            <FormRow inline>
              <FormCol field="custom.department" width="half" :showLabel="false">
                <FormSelect>
                  <option value="JLIC_Ariel">Ariel</option>
                  <option value="JLIC_BarIlan">Bar Ilan</option>
                  <option value="JLIC_BenGurion">Ben Gurion</option>
                  <option value="JLIC_Binghamton">Binghamton</option>
                  <option value="JLIC_Brandeis">Brandeis</option>
                  <option value="JLIC_BrooklynCollege">Brooklyn</option>
                  <option value="JLIC_CSUN">CSUN</option>
                  <option value="JLIC_Columbia">Columbia/Barnard</option>
                  <option value="JLIC_Cornell">Cornell</option>
                  <!-- <option value="JLIC_Atlanta">Greater Atlanta</option> -->
                  <!-- <option value="Greater Toronto">Greater Toronto</option> -->
                  <option value="JLIC_IDCHerzliya">IDC- Herzliya</option>
                  <option value="JLIC_Jerusalem_Student_Center">JLIC Student Center</option>
                  <option value="JLIC_Jerusalem">JLIC Jerusalem</option>
                  <option value="JLIC_JohnsHopkins">Johns Hopkins</option>
                  <option value="Growth Program">Lone Soldier/B’not Sherut project</option>
                  <option value="Kesharim">Kesharim</option>
                  <option value="JLIC_MachonLev">Machon Lev</option>
                  <option value="JLIC_MachonTal">Machon Tal</option>
                  <option value="JLIC_McMaster">McMaster</option>
                  <option value="JLIC_Michigan">Michigan</option>
                  <option value="JLIC_NYU">NYU</option>
                  <option value="JLIC_TLV">TLV</option>
                  <option value="JLIC_Princeton">Princeton</option>
                  <option value="JLIC_Queens">Queens</option>
                  <option value="JLIC_Rutgers">Rutgers</option>
                  <option value="JLIC_SMC">SMC</option>
                  <option value="JLIC_Technion">Technion</option>
                  <option value="JLIC_TAU">MD Katz OU-JLIC at Tel Aviv University</option>
                  <option value="JLIC_UCLA">UCLA</option>
                  <option value="JLIC_Chicago">UChicago</option>
                  <option value="JLIC_University_of_Florida">University of Florida</option>
                  <!-- <option value="JLIC_Uillinois">University of Illinois</option> -->
                  <option value="JLIC_UMD">University of Maryland</option>
                  <!-- <option value="JLIC_UMASS">UMass</option> -->
                  <option value="JLIC_Penn">Penn</option>
                  <option value="JLIC_WashingtonUniversity">Wash U</option>
                  <option value="JLIC_Western">Western</option>
                  <option value="JLIC_Yale">Yale</option>
                </FormSelect>
              </FormCol>
            </FormRow>
            <FormRow inline>
              <FormCol field="custom.designation" width="half">
                <FormSelect>
                <option value="General Donation">Any Program</option>
                <option value="Campus book Fund">Campus book Fund</option>
                <option value="Programming fund">Programming fund</option>
                <option value="JLIC Couple">
                  Presence of OU-JLIC couple at a Campus
                </option>
                <option value="Shabbat Meals">Shabbat Meals</option>
                <option value="Passover">Pesach</option>
              </FormSelect>
              </FormCol>
            </FormRow>
            <FormRow>
              <FormLabel>
                <input type="checkbox" field="custom.naming" /> I would like to be
                contacted regarding naming opportunities
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
          <Receipt :receipts="['us', 'israel']"/>
          </FormRow>
          <br>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { computed, defineComponent, onMounted, ref, watch} from 'vue';
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";


export default defineComponent({
  setup() {
    const { setValue, getValue, form } = usePaymentForm();

    const params = queryParams();

    const showDesignation = computed(() => {
      const dept = getValue('custom.department');
      return dept !== 'Jerusalem Baka Center' && dept !== 'Growth Program';
    });


    watch(
      () => getValue("custom.department"),
      (val) => {
        if (val == "Growth Program" || !val) {
          setValue("applications.0.department", "JLIC");
          setValue("applications.0.campaign", "Growth Program");
          setValue("applications.0.subCampaign", "Lone Soldier/B’not Sherut project");        
        } else if (val == "Jerusalem Baka Center") {
          setValue("applications.0.department", "JLIC");
          setValue("applications.0.campaign", "Growth Program");
          setValue("applications.0.subCampaign", "Jerusalem Baka Center");        
        } else if (val == "Kesharim") {
          setValue("applications.0.department", "JLIC");
          setValue("applications.0.campaign", "Kesharim");
        } 
        else {
          setValue("applications.0.department", val);
          setValue("applications.0.campaign", "General Donation");
        }
      }
    );


    if (params.code) {
      //@ts-ignore
      if (params.code === "support") {
        setValue("applications.0.campaign", "ADM JLIC Campaign");
        setValue("applications.0.subCampaign", "Direct Mail");
      } else if(params.code === "supportus"){
        setValue("applications.0.campaign", "ADM JLIC Campaign");
        setValue("applications.0.subCampaign", "Telemarketing");
      } else {
        setValue("applications.0.campaign", "general");
      }
    }


    return {
      form,
      setValue,
      showDesignation
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}

.jlic-donation-form ::v-deep {
  h2 {
    border-bottom: 1px solid #ccc;
    display: block;
    width: 100%;
    padding: 0;
    margin-bottom: 25px;
    font-size: 24px;
    line-height: inherit;
    color: #333333;
    text-transform: none;
    letter-spacing: 0px;
    font-family: inherit;
    @media (min-width: 720px) {
      margin-top: 30px;
    }

    &::before {
      content: none;
    }
  }
  .styled-radio.styled-radio--ou-donation.row,
  .styled-radio-container.styled-radio-container--ou-donation.row {
    label {
      background: #aaa;
      color: white;
      width: 100%;
      text-align: center;
      border-radius: 2px;
      border: 1px solid #999;
      &:hover {
        background: #999;
      }
    }

    input[type="radio"]:checked + label {
      background: #bf1b31;
    }

  }
}
</style>
